<template>
    <div>
        <flight-loader :is-loading="loading" />
        <v-carousel v-if="details.itinerary.length" :continuous="false" height="fit-content" hide-delimiters>
            <template v-slot:prev="{props}">
                <v-icon size="x-large" class="control-btn" @click="props.onClick">mdi-chevron-left</v-icon>
            </template>
            <template v-slot:next="{props}">
                <v-icon size="x-large" class="control-btn" @click="props.onClick">mdi-chevron-right</v-icon>
            </template>
            <v-carousel-item v-for="(itinerary, index) in details.itinerary" :key="`itinerary-${index}`">
                <div class="px-0 px-md-10">
                    <flight-itinerary-detail :itinerary="itinerary">
                        <slot />
                    </flight-itinerary-detail>
                </div>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FlightItineraryDetail from '~/components/flights/search/offers/FlightItineraryDetail.vue'
    import FlightLoader from '@/components/flights/snippets/FlightLoader.vue'

    @Component({
        components: {
            FlightItineraryDetail,
            FlightLoader,
        },
    })
    export class FlightDetail extends Vue {
        @Prop() offer

        details = {itinerary: []}
        loading = false

        mounted() {
            this.getDetails()
        }

        async getDetails() {
            this.loading = true
            const rq = {}
            if (this.offer.offerKey) {
                rq.offerKey = this.offer.offerKey
            }
            if (this.offer.processId) {
                rq.processId = this.offer.processId
            }
            if (this.offer.unitKey) {
                rq.unitKey = this.offer.unitKey
            }
            try {
                this.details = await this.$api.flightInfo.get(rq)
            } catch (e: any) {
                if (e.status === 400) EventBus.$emit('OFFER_EXPIRED_EVENT')
            }
            this.loading = false
            if (this.details.itinerary.length === 0) {
                this.details.itinerary = this.offer.itinerary.map(itinerary => {
                    const segments = itinerary.segments.map(segment => {
                        return {
                            arrivalDate: segment.arrival.date,
                            departureDate: segment.departure.date,
                            arrivalAirportCode: segment.arrival.airportCode,
                            arrivalAirportDescription: segment.arrival.airportDescription,
                            departureAirportCode: segment.departure.airportCode,
                            departureAirportDescription: segment.departure.airportDescription,
                            categoryClass: segment.class,
                            operatingAirline: segment.marketingAirline,
                            marketingAirline: segment.marketingAirline,
                            flightNumber: segment.flightNumber,
                            aircraftName: segment.aircraft.name,
                            duration: segment.duration,
                            baggageInfo: segment.baggageInfo,
                            brandedFareName: segment.brandedFareName,
                        }
                    })
                    return {
                        segments,
                        duration: itinerary.duration,
                    }
                })
            } else {
                this.details.itinerary = this.details.itinerary.map((itinerary, itineraryIndex) => {
                    itinerary.segments = itinerary.segments.map((segment, segmentIndex) => {
                        return Object.assign(segment, {
                            baggageInfo: this.offer.itinerary[itineraryIndex].segments[segmentIndex].baggageInfo,
                            brandedFareName:
                                this.offer.itinerary[itineraryIndex].segments[segmentIndex].brandedFareName,
                        })
                    })
                    return itinerary
                })
            }
        }
    }

    export default FlightDetail
</script>

<style lang="scss" scoped>
    .control-btn:hover {
        background-color: rgba(128, 128, 128, 0.1);
        border-radius: 50%;
    }
    :deep(.v-window__controls) {
        padding: 0 0;
    }
</style>
